<template>
  <nb-container :style="{ height: '100%' }">
    <nb-navbar
      :collapsed="collapsed"
      :width-collapsed="navBarParams.widthCollapsed"
      :width="navBarParams.width"
      slot="sidebar"
      :theme="navBarParams.theme"
      shadow-padding="60px"
      @click-btn-toggle="toggle(navBarParams.isAdmin)"
      :header="navBarParams.header"
      v-bind:class="navBarParams.background"
    >
      <!-- go to menu for explanation -->
      <nb-menu mode="vertical" domain="airport" router>
        <!-- Second slot : contain a menu -->
        <div
          v-for="item in items"
          :key="item.name"
          @click="changeCurrentScreenName(item.name)"
        >
          <nb-menu-item :to="item.path" :icon="item.icon">
            {{ item.name }}
          </nb-menu-item>
        </div>
      </nb-menu>
      <nb-navbar-spacer></nb-navbar-spacer>
      <div v-if="collapsed === true" class="navbar-bottom-icon">
        <nb-icon name="navblue-brand" size="normal"> </nb-icon>
      </div>
      <nb-icon name="navblue" size="48px" v-if="collapsed === false"></nb-icon>
    </nb-navbar>

    <div slot="header">
      <nb-header
        class="no-display"
        :title="currentScreen"
        :body-style="{ width: '100%', 'background-color': 'transparent' }"
      >
        <!--<template v-slot:action>
          <nb-button icon="edit" simple color="flightops"></nb-button>
          <nb-header-separator></nb-header-separator>
          <nb-button simple color="flightops">action 1</nb-button>
          <nb-header-action-group>
            <nb-header-separator></nb-header-separator>
            <nb-button icon="task" simple color="secondary"></nb-button>
            <nb-button icon="comment" simple color="secondary"></nb-button>
            <nb-button icon="notification" simple color="secondary"></nb-button>
          </nb-header-action-group>
        </template>
        -->
        <template v-slot:menu>
          <nb-header-separator></nb-header-separator>
          <nb-dropdown trigger="click">
            <a
              ><nb-avatar
                :username="getCompiledUsername"
                :size="24"
                dropdown
                background-color="yellow"
            /></a>
            <nb-dropdown-menu slot="dropdown">
              <nb-dropdown-item id="settings"
                ><div @click="settingsClick">
                  {{ $t("common.myAccount.settings.label") }}
                </div></nb-dropdown-item
              >
              <nb-dropdown-item
                ><div @click="aboutClick">
                  About
                </div></nb-dropdown-item
              >
              <nb-dropdown-item divided
                ><div @click="logoutClick">
                  {{ $t("common.myAccount.logout.label") }}
                </div></nb-dropdown-item
              >
            </nb-dropdown-menu>
          </nb-dropdown>
        </template>
      </nb-header>
    </div>
    <div slot="main" class="main-container">
      <router-view></router-view>
    </div>
  </nb-container>
</template>
<script>
import Vue from "vue";
import Component from "vue-class-component";
import router from "@/router/router";
import store from "@/store/store";
import { mapGetters } from "vuex";
import {
  Header as NbHeader,
  Navbar as NbNavbar,
  NavbarSpacer as NbNavbarSpacer,
  Menu as NbMenu,
  Icon as NbIcon,
  Avatar as NbAvatar,
  HeaderSeparator as NbHeaderSeparator,
  Modal as NbModal,
  Form as NbForm,
  FormItem as NbFormItem,
  Input as NbInput,
  Dropdown as NbDropdown,
  DropdownItem as NbDropdownItem,
  DropdownMenu as NbDropdownMenu
} from "@navblue/navblue-ui";

@Component({
  components: {
    NbHeader,
    NbNavbar,
    NbNavbarSpacer,
    NbIcon,
    NbHeaderSeparator,
    NbAvatar,
    NbModal,
    NbForm,
    NbFormItem,
    NbInput,
    NbDropdown,
    NbDropdownItem,
    NbDropdownMenu
  },
  computed: {
    ...mapGetters(["getCompiledUsername"])
  },
  props: {
    title: {
      type: String,
      required: false
    },
    userData: {
      type: Object,
      required: false
    }
  }
})
export default class Main extends Vue {
  data() {
    return {
      navBarParams: {
        widthCollapsed: "48px",
        width: "256px",
        theme: "light",
        header: "Welcome",
        click: "toggle",
        isAdmin: false,
        background: ""
      },
      nbHeaderParams: {
        title: "Product name",
        description: "description"
      },
      currentScreen: "MAIN PAGE",
      collapsed: true,
      mainItems: [
        {
          name: "MAIN PAGE",
          icon: "dashboard",
          path: "/myapp",
          title: "MAIN PAGE"
        },

        {
          name: "DATABASES",
          icon: "data_base",
          path: "/databases",
          title: "DATABASES"
        },

        {
          name: "BULLETINS",
          icon: "flag",
          path: "/bulletins",
          title: "BULLETINS"
        }

        /*{
          name: "DOCUMENTATION",
          icon: "document",
          path: "/documentation",
          title: "DOCUMENTATION"
        },

        {
          name: "CALENDAR",
          icon: "event",
          path: "/calendar",
          title: "CALENDAR"
        },*/
      ],
      items: this.mainItems
    };
  }

  created() {
    this.items = this.mainItems;
  }

  toggle(isAdmin) {
    if (isAdmin) {
      router.push("myapp");
      this.navBarParams = {
        widthCollapsed: "48px",
        width: "256px",
        theme: "light",
        header: "Welcome",
        click: "toggle",
        isAdmin: false,
        background: ""
      };
      this.nbHeaderParams = {
        title: "Product name",
        description: "description"
      };
      this.items = this.mainItems;
      this.collapsed = true;
    } else {
      this.collapsed = !this.collapsed;
    }
  }
  settingsClick() {
    router.push("admin");
    this.collapsed = false;
    this.navBarParams = {
      widthCollapsed: "48px",
      width: "160px",
      theme: "light",
      header: "BACK TO APP",
      isAdmin: true,
      background: "navbar-admin-background"
    };
    this.nbHeaderParams = {
      title: "Parameters",
      description: "Header subtitle (optional)"
    };
    this.items = [{ name: "My account", icon: "user", path: "admin" }];
  }
  logoutClick() {
    router.push("login");
  }
  aboutClick() {
    this.$Notify({
      title: "The actual version of the portal is :",
      message: process.env.VUE_APP_PORTAL_VERSION,
      type: "success",
      duration: 0
    });
  }
  changeCurrentScreenName(name) {
    this.currentScreen = name;
  }
}
</script>
<style lang="scss">
.nb-container-layout__right-side__main {
  background-image: linear-gradient(
    0deg,
    rgba(238, 82, 102, 0.1) 0%,
    rgba(255, 209, 124, 0.1) 100%
  );
  background-color: transparent !important;
}
.navbar-admin-background {
  background-color: var(--color-grey-8) !important;
}
.navbar-bottom-icon {
  display: inline-flex;
  justify-content: center;
  padding-bottom: var(--spacer-default);
}
.dropdown-header__avatar {
  cursor: pointer;
  .nb-avatar {
    outline: 0;
  }
}
</style>
